import {
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR,
  RolodexPermissions,
} from 'features/auth'

export const SiteMapVizEditorPermissionsList: RolodexPermissions[] = [
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN,
]
